import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=81915fd2&scoped=true&"
import script from "./Snackbar.ts?vue&type=script&lang=ts&"
export * from "./Snackbar.ts?vue&type=script&lang=ts&"
import style0 from "./Snackbar.scss?vue&type=style&index=0&id=81915fd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81915fd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
